/**
 * AuthContainer - Renders BottomSheet on mobile, Modal on desktop
 */
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import AuthModal from './AuthModal';
import AuthBottomSheet from './AuthBottomSheet';

function AuthContainer() {
  const isMobile = useIsMobile();
  return isMobile ? <AuthBottomSheet /> : <AuthModal />;
}

export default AuthContainer;
